import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

import '../../styles/components/toc.scss'

class Toc extends React.Component {
  render() {
    let post = this.props.post
    let headings = post.html.match(/<[hH][1-6].*?>.*?<\/[hH][1-6]>/gm)
    let toc = []
    let tocStructure

    if (headings && headings.length > 3) {
      headings.forEach(h => {
        if (h.length > 9) {
          let obj = new Object()
          obj.id = (/id=["|'].*?["|']/).test(h)?h.match(/id=["|'].*?["|']/)[0].replace(/id=["|']/, '').replace(/["|']$/, ''):null
          obj.text = h.replace(/<\/?[^>]+(>|$)/g, '').replace(/^\d{0,2}[.]/, '')
          obj.level = (/<\/[hH].*?>/).test(h)?Number(h.match(/<\/[hH].*?>/)[0].replace('</h', '').replace('>', '')):0
          toc.push(obj)
        }
      })

      tocStructure = toc.map((item, index) => {
        return <li key={(index + item.id).toString()} className={`toc__item level${item.level}`}>
          {
            item.id
              ?<AnchorLink href={`#${item.id}`} offset={()=>document.querySelector('.site-head').offsetHeight+16} dangerouslySetInnerHTML={{ __html: item.text }} />
              :<span dangerouslySetInnerHTML={{ __html: item.text}} />
          }
        </li>
      })
    }

    return (
      <>
        {tocStructure && <nav className="toc">
          <header className="toc__header h3" dangerouslySetInnerHTML={{__html: this.props.tocHeader}} />
          <ol className="toc__list">
            {tocStructure}
          </ol>
        </nav>}
      </>
    )
  }
}

export default Toc